'use client';

import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(
  '3021402135613874e200c1032bd1c1f5Tz0xMjQ0NDksRT0xODAwMjMwMzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
);

export default function MuiXLicense() {
  return null;
}
